const breakpoints = ["mobile", "tablet", "desktop", "large"];

const responsiveRangeProps = ({above, below}) => {
    if (!above && !below) {
        return [false, false, false, false];
    }

    const startIndex = above ? breakpoints.indexOf(above) + 1 : 0;
    const endIndex = below ? breakpoints.indexOf(below) - 1 : breakpoints.length - 1;
    const range = breakpoints.slice(startIndex, endIndex + 1);

    const includeMobile = range.indexOf("mobile") >= 0;
    const includeTablet = range.indexOf("tablet") >= 0;
    const includeDesktop = range.indexOf("desktop") >= 0;
    const includeLargeDesktop = range.indexOf("large") >= 0;

    return [includeMobile, includeTablet, includeDesktop, includeLargeDesktop];
};

export default responsiveRangeProps;
